exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewer[data-v-392bca61]{width:100%;height:100%;position:relative}", ""]);

// exports
